import { createSelector } from 'reselect'

export const getFormFields = createSelector(
  state => state && state.common && state.common.form && state.common.form.fields
    ? state.common.form.fields : null,
  fields => fields
)
